import * as React from "react"
import { styled } from "@mui/material/styles"
import Grid from "@mui/material/Grid"
// import Paper from '@mui/material/Paper';
import Typography from "@mui/material/Typography"
// import ButtonBase from '@mui/material/ButtonBase';
// import ResourcesGrid from "../../features/resources-grid/ResourcesGrid"
// import ResourcesCategories from "../../features/resources-categories/ResourcesCategories"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEnvelope,
  faPhone,
  faLocationDot,
  faCircleArrowUp,
} from "@fortawesome/free-solid-svg-icons"
import "./Footer.css"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import logo from "./logo_transparent.png"
import {Link} from "react-router-dom"


function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  })
}

export default function Footer() {
  return (
    <footer>
      <div className="grid-container">
        <div className="left">
          <Link to="/" >
            <img src={logo} className="App-logo-4" alt="logo" />
          </Link>
        </div>
        <div className="middle">
          {/*
          <p className="linkText">
            <a href="/jobs-readiness">Job Readiness</a>
          </p>
          */}
          <p className="linkText">
            <a href="/resources">Resources</a>
          </p>
          <p className="linkText">
            <a href="/success-stories">Success Stories</a>
          </p>
          <p className="linkText">
            <a href="/contact-us">Contact Us</a>
          </p>
          <p className="linkText">
            <a href="/check-eligibility">Check Eligibility</a>
          </p>
        </div>
        <div className="right">
          <div className="addyText">
            <FontAwesomeIcon icon={faLocationDot as IconProp} /> &nbsp;Holy
            Assembly Church or God in Christ
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;55 East Villa Street
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pasadena, CA 91103
            <br />
            <p />
          </div>
          <br />
          <div className="contactText">
            <FontAwesomeIcon icon={faPhone as IconProp} /> &nbsp;(626) 437-3509
          </div>
          <br />
          <div className="contactText">
            <FontAwesomeIcon icon={faEnvelope as IconProp} />{" "}
            &nbsp;&nbsp;friendsofthemiraclemile.org
            <div className="arrow" onClick={() => scrollToTop()}>
              <FontAwesomeIcon icon={faCircleArrowUp as IconProp} />
            </div>
          </div>
        </div>

        <p className="copyRight">© 2022 Friends of the Miracle Mile</p>
      </div>
      {/* <Grid container spacing={4}>
        <Grid item xs={3} sm container>
          <Grid item xs container direction="column" spacing={2}>
            <Grid item xs>
              <p className = "logoText">
                FotMM
              </p>
            </Grid>
            <Grid item>
              <p className = "copyRight">
                 © 2022 Friends of the Miracle Mile
              </p>
            </Grid>
          </Grid>
          <Grid item xs={3}>
          <p className = "linkText"><a href="/jobreadiness">Job Readiness</a></p>
          <p className = "linkText"><a href="/resources">Resources</a></p>
          <p className = "linkText"><a href="/">Success Stories</a></p>
          <p className = "linkText"><a href="/">Contact Us</a></p>
          <p className = "linkText"><a href="/">Check Eligibility</a></p>
        </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1" component="div" align="left">
              Holy Assembly Church or God in Christ<br />
              55 East Villa Street<br />
              Pasadena, CA 91103<br />
            </Typography>
            <p className="contactText">
              (626) 437-3509
            </p>
            <p className="contactText">
              friendsofthemiraclemile.org
            </p>
          </Grid>
        </Grid>
      </Grid> */}
    </footer>
  )
}
